import u from "./_isArray.mjs";
import p from "./_isTransformer.mjs";
function s(n, e, a) {
  return function() {
    if (arguments.length === 0)
      return a();
    var r = arguments[arguments.length - 1];
    if (!u(r)) {
      for (var t = 0; t < n.length; ) {
        if (typeof r[n[t]] == "function")
          return r[n[t]].apply(r, Array.prototype.slice.call(arguments, 0, -1));
        t += 1;
      }
      if (p(r)) {
        var l = e.apply(null, Array.prototype.slice.call(arguments, 0, -1));
        return l(r);
      }
    }
    return a.apply(this, arguments);
  };
}
export {
  s as default
};
